(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial-founder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const TALLY = [
      '',
      'One sign. Shogun started with one too.',
      'Two signs. Worth taking seriously.',
      "Three signs. I'd start now.",
      "Four signs. I'd start now.",
      "Five signs. I'd start now, and mention it to your vet.",
      "All six. I'd start now, and mention it to your vet.",
    ];

    function initChecklists(root) {
      for (const group of root.querySelectorAll('[data-adv-checks]')) {
        if (group.dataset.advReady) continue;
        group.dataset.advReady = 'true';
        const article = group.closest('.adv');
        const tally = article && article.querySelector('[data-adv-tally]');
        const boxes = [...group.querySelectorAll('input[type="checkbox"]')];
        group.addEventListener('change', () => {
          if (!tally) return;
          tally.textContent = TALLY[boxes.filter((box) => box.checked).length] || '';
        });
      }
    }

    initChecklists(document);
    document.addEventListener('shopify:section:load', (event) => initChecklists(event.target));

    class AdvOffer extends HTMLElement {
      connectedCallback() {
        this.weights = [...this.querySelectorAll('[data-adv-weight]')];
        this.plans = [...this.querySelectorAll('[data-adv-plan]')];
        this.planField = this.querySelector('[data-selling-plan-input]');
        this.priceEl = this.querySelector('[data-adv-price]');
        this.compareEl = this.querySelector('[data-adv-compare]');
        this.thenEl = this.querySelector('[data-adv-then]');
        this.lastsEl = this.querySelector('[data-adv-lasts]');
        this.addEventListener('change', this.sync);
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.sync);
      }

      sync = () => {
        const weight = this.weights.find((input) => input.checked);
        const plan = this.plans.find((input) => input.checked);

        if (weight) {
          const recurring = weight.dataset.recurring || '';
          if (this.priceEl) this.priceEl.textContent = weight.dataset.price || '';
          if (this.compareEl) {
            this.compareEl.textContent = recurring;
            this.compareEl.hidden = recurring === '';
          }
          if (this.thenEl && recurring) this.thenEl.textContent = recurring;
          if (this.lastsEl) this.lastsEl.textContent = weight.dataset.lasts || '';
        }

        /* The weight tier decides the subscription cadence, so the selling
           plan submitted is the checked tier's plan; one jar sends none. */
        if (this.planField) {
          const subscribe = !plan || plan.value === 'subscribe';
          this.planField.value = subscribe && weight ? weight.dataset.planId : '';
        }
      };
    }

    if (!customElements.get('adv-offer')) customElements.define('adv-offer', AdvOffer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advertorial-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const TALLY = [
      '',
      'One sign. Shogun started with one too.',
      'Two signs. Worth taking seriously.',
      "Three signs. I'd start now.",
      "Four signs. I'd start now.",
      "Five signs. I'd start now, and mention it to your vet.",
      "All six. I'd start now, and mention it to your vet.",
    ];

    function initChecklists(root) {
      for (const group of root.querySelectorAll('[data-adv-checks]')) {
        if (group.dataset.advReady) continue;
        group.dataset.advReady = 'true';
        const article = group.closest('.adv');
        const tally = article && article.querySelector('[data-adv-tally]');
        const boxes = [...group.querySelectorAll('input[type="checkbox"]')];
        group.addEventListener('change', () => {
          if (!tally) return;
          tally.textContent = TALLY[boxes.filter((box) => box.checked).length] || '';
        });
      }
    }

    initChecklists(document);
    document.addEventListener('shopify:section:load', (event) => initChecklists(event.target));

    class AdvOffer extends HTMLElement {
      connectedCallback() {
        this.weights = [...this.querySelectorAll('[data-adv-weight]')];
        this.plans = [...this.querySelectorAll('[data-adv-plan]')];
        this.planField = this.querySelector('[data-selling-plan-input]');
        this.priceEl = this.querySelector('[data-adv-price]');
        this.compareEl = this.querySelector('[data-adv-compare]');
        this.thenEl = this.querySelector('[data-adv-then]');
        this.lastsEl = this.querySelector('[data-adv-lasts]');
        this.addEventListener('change', this.sync);
        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.sync);
      }

      sync = () => {
        const weight = this.weights.find((input) => input.checked);
        const plan = this.plans.find((input) => input.checked);

        if (weight) {
          const recurring = weight.dataset.recurring || '';
          if (this.priceEl) this.priceEl.textContent = weight.dataset.price || '';
          if (this.compareEl) {
            this.compareEl.textContent = recurring;
            this.compareEl.hidden = recurring === '';
          }
          if (this.thenEl && recurring) this.thenEl.textContent = recurring;
          if (this.lastsEl) this.lastsEl.textContent = weight.dataset.lasts || '';
        }

        /* The weight tier decides the subscription cadence, so the selling
           plan submitted is the checked tier's plan; one jar sends none. */
        if (this.planField) {
          const subscribe = !plan || plan.value === 'subscribe';
          this.planField.value = subscribe && weight ? weight.dataset.planId : '';
        }
      };
    }

    if (!customElements.get('adv-offer')) customElements.define('adv-offer', AdvOffer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-badge-row"] && !Shopify.designMode) return;
  try {
    
  class TrustBadgeRow extends HTMLElement {
    #track = null;
    #toggle = null;
    #timer = null;
    #hovered = false;
    #userPaused = false;
    #reducedMotion = null;
    #mobile = null;

    connectedCallback() {
      this.#track = this.querySelector('[data-track]');
      if (!this.#track || !this.hasAttribute('data-autoplay')) return;

      this.#toggle = this.querySelector('[data-toggle]');
      this.#reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.#mobile = window.matchMedia('(max-width: 989px)');

      this.#toggle?.addEventListener('click', this.#onToggleClick);
      this.addEventListener('pointerenter', this.#onPointerEnter);
      this.addEventListener('pointerleave', this.#onPointerLeave);
      this.addEventListener('focusin', this.#onPointerEnter);
      this.addEventListener('focusout', this.#onPointerLeave);
      this.#reducedMotion.addEventListener('change', this.#onEnvironmentChange);
      this.#mobile.addEventListener('change', this.#onEnvironmentChange);

      this.#sync();
    }

    disconnectedCallback() {
      this.#stop();
      this.#toggle?.removeEventListener('click', this.#onToggleClick);
      this.removeEventListener('pointerenter', this.#onPointerEnter);
      this.removeEventListener('pointerleave', this.#onPointerLeave);
      this.removeEventListener('focusin', this.#onPointerEnter);
      this.removeEventListener('focusout', this.#onPointerLeave);
      this.#reducedMotion?.removeEventListener('change', this.#onEnvironmentChange);
      this.#mobile?.removeEventListener('change', this.#onEnvironmentChange);
    }

    /** Autoplay only runs on mobile, with motion allowed, and not paused. */
    get #shouldRun() {
      if (this.#userPaused || this.#hovered) return false;
      if (this.#reducedMotion.matches) return false;
      return this.#mobile.matches;
    }

    #sync = () => {
      if (this.#shouldRun) {
        this.#start();
        return;
      }
      this.#stop();
    };

    #start() {
      if (this.#timer) return;
      const delay = Number(this.dataset.delay) || 5000;
      this.#timer = window.setInterval(this.#advance, delay);
    }

    #stop() {
      if (!this.#timer) return;
      window.clearInterval(this.#timer);
      this.#timer = null;
    }

    #advance = () => {
      const track = this.#track;
      const item = track.querySelector('.trust-row__item');
      if (!item) return;

      const step = item.getBoundingClientRect().width;
      const maxScroll = track.scrollWidth - track.clientWidth;
      // Within one step of the end, wrap back to the start.
      const next = track.scrollLeft >= maxScroll - step / 2 ? 0 : track.scrollLeft + step;
      track.scrollTo({ left: next, behavior: 'smooth' });
    };

    #onToggleClick = () => {
      this.#userPaused = !this.#userPaused;
      const { labelPause, labelPlay } = this.#toggle.dataset;
      this.#toggle.setAttribute('aria-pressed', String(this.#userPaused));
      this.#toggle.setAttribute('aria-label', this.#userPaused ? labelPlay : labelPause);
      this.#sync();
    };

    #onPointerEnter = () => {
      this.#hovered = true;
      this.#sync();
    };

    #onPointerLeave = () => {
      this.#hovered = false;
      this.#sync();
    };

    #onEnvironmentChange = () => this.#sync();
  }

  if (!customElements.get('trust-badge-row')) {
    customElements.define('trust-badge-row', TrustBadgeRow);
  }

  } catch(e) { console.error(e); }
})();
})();
